module.exports = "<select class=\"w3-select w3-block w3-border w3-round\"\r\n  [(ngModel)]=\"value\"\r\n  [disabled]=\"isDisabled\">\r\n  <option [value]=\"null\">{{nullLabel}}</option>\r\n  <option *ngFor=\"let r of roles\" [value]=\"r.key\">{{r.value}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-role-select/ztsi-role-select.component.html
// module id = ./src/app/components/shared/ztsi-role-select/ztsi-role-select.component.html
// module chunks = main